import { Component, inject } from '@angular/core';

import { UiStore } from '../shared/state/ui.store';
import { MatSidenavContainer, MatSidenav } from '@angular/material/sidenav';
import { NavBrandComponent } from './nav-brand/nav-brand.component';
import { NavLeftComponent } from './nav-left/nav-left.component';
import { NavHeaderComponent } from './nav-header/nav-header.component';
import { RouterOutlet } from '@angular/router';
import { NavLoadingComponent } from './nav-loading/nav-loading.component';
import { NavFooterComponent } from './nav-footer/nav-footer.component';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
    imports: [MatSidenavContainer, MatSidenav, NavBrandComponent, NavLeftComponent, NavHeaderComponent, RouterOutlet, NavLoadingComponent, NavFooterComponent]
})
export class NavigationComponent {
  protected readonly isLoading = inject(UiStore).isLoading;

  sidenavOpen = false;
  sidenavMode = 'side';
  // sideNavMode = 'push';
  sidenavAlign = 'start';

  settings = {
    colorClasses: {
      header: 'warn',
      footer: 'stbui-background-blue',
      brand: 'total',
      navigation: 'stbui-background-dark'
    },
    layout: {
      mode: 'fullwidth',
      navigation: 'left',
      header: 'below',
      footer: 'below'
    }
  };

  onActivate(event: unknown, scrollContainer: HTMLElement) {
    scrollContainer.scrollTop = 0;
  }

}
